<template>
  <div class="tab__content clear">
    <div v-if="tournament.type == 1" class="floated-box right">
      <discord-widget id="discord" />
    </div>
    <div v-html="tournament.info" />
  </div>
</template>

<script>
import ymaps from "ymaps";
import DiscordWidget from "@/components/widgets/discord";
import { mapGetters } from "vuex";
import { setTimeout } from "timers";

import showImage from "@/services/common/showImage";

export default {
  components: { DiscordWidget },

  computed: {
    ...mapGetters("tournaments", ["tournament"])
  },

  watch: {
    "tournament.id": function() {
      this.initMap();
    }
  },

  mounted() {
    this.initMap();
    this.initZoomListners();
  },

  beforeDestroy() {
    this.removeZoomListners();
  },

  methods: {
    getContentImages() {
      return [].slice.call(this.$el.querySelectorAll("p img[src]"));
    },

    initZoomListners() {
      let imageList = this.getContentImages();
      imageList.forEach(node =>
        node.addEventListener("click", this.contentImageZoomHandler)
      );
    },

    removeZoomListners() {
      let imageList = this.getContentImages();
      imageList.forEach(node =>
        node.removeEventListener("click", this.contentImageZoomHandler)
      );
    },

    contentImageZoomHandler(e) {
      if (e.target && e.target.src) {
        e.preventDefault();
        e.stopPropagation();

        showImage(e.target.src);
      }
    },

    initMap() {
      this.$nextTick(this.createMap);
    },

    createMap() {
      const mapContainer = document.getElementById("yaMap");
      if (mapContainer) {
        mapContainer.innerHTML = "";

        ymaps.load().then(Maps => {
          const Map = new Maps.Map("yaMap", {
            center: [55.849868, 37.497387],
            zoom: 15,
            controls: ["zoomControl", "typeSelector", "fullscreenControl"]
          });

          const Placemark = new Maps.Placemark(
            Map.getCenter(),
            {
              balloonContent: `г. Москва, ул. Смольная, 12, этаж 3<br />студия киберспортивного телеканала «E TV»`
            },
            {
              iconLayout: "default#image",
              iconImageHref: require("@/assets/img/logo.png"),
              balloonOffset: [0, -50],
              iconImageSize: [96, 118],
              iconImageOffset: [-48, -59],
              hideIconOnBalloonOpen: false
            }
          );

          Map.geoObjects.add(Placemark);

          setTimeout(() => {
            Placemark.balloon.open();
          }, 10);
        });
      }
    }
  }
};
</script>

<style lang="scss">
#yaMap {
  width: 100%;
  height: 324px;
  border-radius: 5px;
  overflow: hidden;
}
</style>
